export class CannotOpenSession extends Error {
    constructor(message?: string) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
        this.name = CannotOpenSession.name;
    }
}

export class CadreExerciceIsMissing extends Error {
    constructor(message?: string) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
        this.name = CadreExerciceIsMissing.name;
    }
}

export class CannotCreateTlsiConnector extends Error {
    constructor(message?: string) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
        this.name = CannotCreateTlsiConnector.name;
    }
}

export class CannotCreateInsiConnector extends Error {
    constructor(message?: string) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
        this.name = CannotCreateInsiConnector.name;
    }
}

export class NoIdentityInfos extends Error {
    constructor(message?: string) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
        this.name = NoIdentityInfos.name;
    }
}

export class CannotRetreiveIns extends Error {
    constructor(message?: string) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
        this.name = CannotRetreiveIns.name;
    }
}

export class NoIdentityFound extends Error {
    constructor(message?: string) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
        this.name = NoIdentityFound.name;
    }
}

export class MultipleIdentitiesFound extends Error {
    constructor(message?: string) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
        this.name = MultipleIdentitiesFound.name;
    }
}

export class NotSameVitaleCard extends Error {
    constructor(message?: string) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
        this.name = NotSameVitaleCard.name;
    }
}
